import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { PublicHeader } from "@/components/public/PublicHeader";
import { PublicFooter } from "@/components/public/PublicFooter";
import { WhatsAppFab } from "@/components/public/WhatsAppFab";
import { LanguageProvider, type Lang } from "@/lib/i18n";

export const Route = createFileRoute("/_public")({
  validateSearch: (search: Record<string, unknown>): { lang?: Lang } => {
    const l = search["lang"];
    return l === "en" || l === "pt" ? { lang: l } : {};
  },
  component: PublicLayout,
});

function PublicLayout() {
  const { lang } = Route.useSearch();
  const navigate = useNavigate();

  const onLangChange = useCallback(
    (l: Lang) => {
      navigate({
        to: ".",
        search: (prev: Record<string, unknown>) => ({
          ...prev,
          lang: l === "es" ? undefined : l,
        }),
        replace: true,
      });
    },
    [navigate],
  );

  return (
    <LanguageProvider urlLang={lang} onLangChange={onLangChange}>
      <div className="flex min-h-screen flex-col bg-background">
        <PublicHeader />
        <main className="flex-1">
          <Outlet />
        </main>
        <PublicFooter />
        <WhatsAppFab />
      </div>
    </LanguageProvider>
  );
}
